import React, { useState, useEffect, useRef } from "react";
import { MenuAlt3Icon, XIcon } from "@heroicons/react/outline";
import logo from "../../../assets/QquzyNew.png";
import { Link, useNavigate, useLocation } from "react-router-dom";

const sections = ["home", "about", "feature", "contact"];

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showNavbar, setShowNavbar] = useState(true);
  const [activeSection, setActiveSection] = useState("home");
  const prevScrollY = useRef(0);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const scrollToSection = (id) => {
    if (location.pathname !== "/") {
      // If not on home page, navigate to home page with section hash
      navigate("/");
      // Set a short timeout to allow navigation to complete before scrolling
      setTimeout(() => {
        if (id === "home") {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        } else {
          const section = document.getElementById(id);
          if (section) {
            section.scrollIntoView({ behavior: "smooth" });
          }
        }
      }, 100);
    } else {
      // Already on home page
      if (id === "home") {
        // For home, scroll to the very top of the page
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      } else {
        const section = document.getElementById(id);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }
    }
    setActiveSection(id);
    setMenuOpen(false); // close mobile menu on click
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > prevScrollY.current && currentScrollY > 100) {
        setShowNavbar(false);
      } else {
        setShowNavbar(true);
      }
      prevScrollY.current = currentScrollY;

      // Set active section based on scroll position
      for (let i = 0; i < sections.length; i++) {
        const section = document.getElementById(sections[i]);
        if (section) {
          const rect = section.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            setActiveSection(sections[i]);
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`bg-white py-4 sm:py-2 md:py-0 px-4 sm:px-6 md:px-12 shadow-md w-full fixed top-0 z-50 transition-transform duration-300 ${showNavbar ? "translate-y-0" : "-translate-y-full"
        }`}
    >
      <div className="flex justify-between items-center">
        {/* Logo */}
        <div
          className="text-2xl font-bold text-gray-700 flex items-center gap-1 cursor-pointer"
          onClick={() => {
            // When logo is clicked, go to home page and scroll to top
            if (location.pathname !== "/") {
              navigate("/");
              // Set a short timeout to allow navigation to complete before scrolling
              setTimeout(() => {
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
              }, 100);
            } else {
              // If already on home page, just scroll to top
              window.scrollTo({
                top: 0,
                behavior: "smooth",
              });
            }
            setActiveSection("home");
          }}
        >
          {/* <span className="text-base md:text-4xl font-bold text-black bg-gradient-to-r from-indigo-600 to-indigo-400 bg-clip-text text-transparent">
            QuzY
          </span> */}
          <img src={logo} alt="Quzy" className="h-12 sm:h-16 md:h-20 w-auto" />
        </div>

        {/* Desktop Menu */}
        <ul className="hidden md:flex gap-6 lg:gap-8 items-center text-sm lg:text-base font-medium text-gray-700">
          {sections.map((section) => (
            <li
              key={section}
              onClick={() => scrollToSection(section)}
              className={`cursor-pointer hover:text-indigo-600 ${activeSection === section ? "text-indigo-600 font-semibold" : ""
                }`}
            >
              {section.charAt(0).toUpperCase() + section.slice(1)}
            </li>
          ))}
        </ul>

        {/* Get Started Button */}
        <div className="hidden md:block">
          <a
            href="https://play.google.com/store/apps/details?id=com.yourcompany.quizzer"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center h-14 transition-all duration-300 transform hover:scale-105 border-2 border-transparent rounded-lg"
          >
            {/* <button className="bg-gradient-to-r from-indigo-600 to-indigo-400 text-white font-semibold px-6 py-2 rounded-full hover:bg-indigo-600 transition-all text-sm">
            Get Started
          </button> */}
          </a>
        </div>

        {/* Hamburger Menu */}
        <div className="md:hidden flex items-center">
          <button onClick={toggleMenu} className="p-2">
            {menuOpen ? (
              <XIcon className="w-7 h-7 text-gray-800" />
            ) : (
              <MenuAlt3Icon className="h-6 w-6" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <ul className="md:hidden flex flex-col gap-4 mt-4 pb-5 text-gray-700 text-base font-medium">
          {sections.map((section) => (
            <li
              key={section}
              onClick={() => scrollToSection(section)}
              className={`cursor-pointer hover:text-indigo-600 ${activeSection === section ? "text-indigo-600 font-semibold" : ""
                }`}
            >
              {section.charAt(0).toUpperCase() + section.slice(1)}
            </li>
          ))}

        </ul>
      )}
    </nav>
  );
};

export default Navbar;
